import React, { useContext, useEffect } from 'react';
import { ExperienceContext, useConfigService, } from '@thd-nucleus/experience-context';
import { Alert } from '@one-thd/sui-atomic-components';
import { usePayments } from '../../../hooks/use-payments';
import { useLoyaltyMembershipDetails } from '../../../hooks/use-loyalty-membership-details';
import { Spinner } from '../../shared/spinner/spinner';
import { CardType } from '../../../constants/payments';
import { PaymentsHeader } from '../payments-header/payments-header';
import { LineOfCredit } from '../pro-house-acount/line-of-credit';
import { TAlertStatus } from '../../../models/common/alert-messages';
import { PROHOUSE_ACCOUNTS_NO_T2C_AUTHORIZED_TENDER_MSG } from '../../../constants/response-warning-messages';
import { shouldShowNoT2CEnrolledTenderWarning } from '../../../utils/pro-house-account';
import { useCustomerInfo } from '../../../hooks/use-customerInfo';
import { CustomerRole } from '../../../models/common/customer';
export const ProHouseAccountList = () => {
    const { loading, linesOfCredit, alertMessage, setAlertMessage, t2cCreditCards, } = usePayments();
    const { channel } = useContext(ExperienceContext);
    const isMobile = channel === 'mobile';
    const { role } = useCustomerInfo();
    const isAdmin = role === CustomerRole.ADMIN;
    const isPHAPermissionsEnabled = !!useConfigService('ENABLE_PHA_PERMISSIONS');
    const { hasPTCOnline } = useLoyaltyMembershipDetails();
    useEffect(() => {
        return () => {
            setAlertMessage(null);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleError = (paymentId, message) => {
        setAlertMessage({
            paymentId,
            alertStatus: TAlertStatus.ERROR,
            text: message,
        });
    };
    const handleSuccess = (paymentId, message) => {
        setAlertMessage({
            paymentId,
            alertStatus: TAlertStatus.SUCCESS,
            text: message,
        });
    };
    const successMessage = alertMessage &&
        alertMessage.alertStatus === TAlertStatus.SUCCESS && (React.createElement("div", { className: isMobile ? 'sui-mt-4' : 'lg:sui-mb-8' },
        React.createElement(Alert, { size: isMobile ? 'small' : 'large', "data-testid": "successMsg", status: alertMessage.alertStatus, onClose: () => setAlertMessage(null) }, alertMessage.text)));
    const errorMessage = alertMessage &&
        alertMessage.alertStatus === TAlertStatus.ERROR && (React.createElement("div", { className: isMobile ? 'sui-mt-4' : 'lg:sui-mb-8' },
        React.createElement(Alert, { "data-testid": "errorMsg", status: alertMessage.alertStatus, onClose: () => setAlertMessage(null) }, alertMessage.text)));
    const shouldShowAlert = !!t2cCreditCards &&
        !!(linesOfCredit === null || linesOfCredit === void 0 ? void 0 : linesOfCredit.paymentCards) &&
        shouldShowNoT2CEnrolledTenderWarning(t2cCreditCards, linesOfCredit.paymentCards);
    const infoMessage = shouldShowAlert && (React.createElement("div", { className: isMobile ? 'sui-mt-4' : 'lg:sui-mb-8' },
        React.createElement(Alert, { "data-testid": "infoMsg", status: TAlertStatus.WARNING }, PROHOUSE_ACCOUNTS_NO_T2C_AUTHORIZED_TENDER_MSG.message)));
    return (React.createElement("div", { "data-testid": "proHouseAccountContent" },
        React.createElement(Spinner, { active: loading }),
        React.createElement(PaymentsHeader, { cardType: CardType.PRO_HOUSE_ACCOUNT, onActionFailure: handleError, onActionSuccess: handleSuccess }),
        infoMessage,
        successMessage,
        errorMessage,
        React.createElement("div", { className: "sui-grid sui-grid-cols-1 sui-gap-y-8 sui-gap-x-8 md:sui-grid-cols-2 2xl:sui-gap-y-16 2xl:sui-grid-cols-3" }, linesOfCredit &&
            linesOfCredit.paymentCards.map((card) => {
                return (React.createElement("div", { key: card.paymentId },
                    React.createElement(LineOfCredit, { card: card, onActionFailure: handleError, onActionSuccess: handleSuccess, shouldDisableProjectLOC: shouldShowAlert, isAdmin: isAdmin, hasPTCPermissions: isPHAPermissionsEnabled && hasPTCOnline })));
            }))));
};
